var map = {
	"./blocks/common/1column/admin/BlockPanel.vue": "1EmX",
	"./blocks/common/2column/admin/BlockPanel.vue": "CzFP",
	"./blocks/common/3column/admin/BlockPanel.vue": "tmkZ",
	"./blocks/common/4column/admin/BlockPanel.vue": "TInM",
	"./blocks/common/leftImageRightText/admin/BlockPanel.vue": "xo95",
	"./blocks/common/leftTextImageRight/admin/BlockPanel.vue": "q+cl",
	"./blocks/common/quote/admin/BlockPanel.vue": "j48f",
	"./blocks/custom/category/admin/BlockPanel.vue": "ALWJ",
	"./blocks/custom/category/admin/LoopItemPanel.vue": "r0n8",
	"./blocks/custom/events/admin/BlockPanel.vue": "u+nt",
	"./blocks/custom/upcomingEvents/admin/BlockPanel.vue": "2h8J",
	"./blocks/utils/text/admin/ckEditorConfig.js": "zaHv"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5reE";